// input: "YYYY-MM-DD"
export function ageInMonth( birth ) {
  const today = new Date();
  const timeDiff = today.getTime() - birth.getTime();
  const yearDiff = timeDiff / (24 * 60 * 60 * 1000) / 365.25;
  return Math.trunc( yearDiff * 12 );
}

export function randomKey() {
  return Math.random().toString(36).slice(2, 12);
}